module.exports = __webpack_public_path__ + "img/logo.ec76900c.jpg";